angular.module('app').controller('ProductGroupController', ProductGroupController);

function ProductGroupController($rootScope, $scope, $http) {

    $scope.deleteProductGroup = function (id) {
        if (confirm('Biztosan törlöd ezt a csoportot?')) {
            var url = productgroupDeleteURL + '/' + id;
            $http.delete(url)
                .then(function successCallback(response) {
                    $('#row-' + id).transition('fade',250,function () {
                        $('#row-' + id).remove();
                    });

                }, function errorCallback(response) {
                    alert("Hiba történt törlés közben.");
                });
        }
    }
}
